export default __webpack_public_path__ + "444f5791a2069748c6fefcd563bcefc2.svg";